import React, { useState } from "react";

import { useFetchProcessedFile, useFetchUploadHistory, useUploadBranches } from "store/backend/apiHooks";
import FileUpload from "components/FileUpload/FileUpload";
import { BRANCH_SCRIPT_ID, UPLOAD_HISTORY_COLUMNS } from "constants/constants";
import { ErrorMessage, PrimaryButton, Table } from "widgets";
import Loader from "shared/Icons/Loader/Loader";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import { formatDate } from "utils/logger";

import styles from "./UploadBranches.module.scss"


const handleOnClickDownloadProcessedFile = (uploadId, openSnackbar, fetchProcessedFile) => {
    if (!uploadId) {
        openSnackbar("No file available for download!", "error");
        return;
    }
    fetchProcessedFile(uploadId, {
        onSuccess: (data) => {
            const link = document.createElement("a");
            link.href = data.signedUrl;
            link.download = "processed_file.csv";
            link.click();
            openSnackbar("Processed File downloaded successfully!", "success");
        },
        onError: (err) => {
            openSnackbar(err.message || "Download failed", "error");
        }
    });
};

const getUploadHistoryTableRows = (uploadHistory, fetchProcessedFile, openSnackbar, isFetchProcessedFileLoading) => {
    if (!Array.isArray(uploadHistory)) {
        return [];
    }
    return uploadHistory.filter((historyRow) => historyRow.scriptId === BRANCH_SCRIPT_ID).map((historyRow) => ({
        fileName: historyRow.fileName,
        status: historyRow.status,
        uploadedAt: formatDate(historyRow.uploadedAt),
        downloadProcessedFile: (
            <PrimaryButton
                onClick={() => handleOnClickDownloadProcessedFile(historyRow.uploadId, openSnackbar, fetchProcessedFile)}
            >
                {isFetchProcessedFileLoading ? "Loading..." : "Download"}
            </PrimaryButton>
        ),
    }));
};

const UploadBranches = () => {
    const { openSnackbar } = useSnackbarContext();
    const [loggedInUserId] = useState(localStorage.getItem("loggedInUserId"));
    const { mutate: UploadBranches, isPending: isUploadBranchesLoading } = useUploadBranches();
    const { data: uploadHistory, isLoading: isUploadHistoryLoading, error: errorMessage } = useFetchUploadHistory(loggedInUserId);
    const { mutate: fetchProcessedFile, isLoading: isFetchProcessedFileLoading } = useFetchProcessedFile();

    const uploadHistoryTableRows = getUploadHistoryTableRows(uploadHistory?.data, fetchProcessedFile, openSnackbar, isFetchProcessedFileLoading);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.title}>Upload Branches</div>
            <div className={styles.uploadBranchesFileContainer}>
                <FileUpload
                    uploadLabel="Upload Branches"
                    onUpload={UploadBranches}
                    isLoading={isUploadBranchesLoading}
                />
                {isUploadHistoryLoading ? <Loader /> :
                    errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : <Table rows={uploadHistoryTableRows} columns={UPLOAD_HISTORY_COLUMNS} />
                }
            </div>

        </div >
    )
}
export default UploadBranches